import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { Head } from '@/components/Head';
import { PublicLayout } from '@/components/Layout';
import { FeatureComparatorPage } from '@/features/misc';
import { useGeoLocation } from '@/hooks/useGeoLocation';

const IframeEmblueWrap = styled.div`
  .payments_iframe_emblue {
    width: 100%;
    height: 210vh;
    border: none;
    overflow: hidden;
  }

  .payments_iframe_emblue:focus-visible {
    outline: none;
  }
`;

const IframeCompareEmblueWrap = styled.div`
  .payments_iframe_compare_emblue {
    width: 100%;
    height: 500vh;
    border: none;
  }

  .payments_iframe_compare_emblue:focus-visible {
    outline: none;
  }
`;

export const FeatureComparator = () => {
  const { isSet, isEurope } = useGeoLocation();
  const { t } = useTranslation();
  return (
    <PublicLayout className="flex">
      <Head page="Comparator" />
      {isSet && isEurope() && <FeatureComparatorPage publicPage={true} />}

      {isSet && !isEurope() && (
        <IframeEmblueWrap>
          <div className="flex justify-center w-full">
            <iframe
              scrolling="no"
              className="payments_iframe_emblue"
              id="inlineFrameEmblue"
              title="Inline Frame Emblue"
              src={t('ProductsPublicPage.iframeEmblue')}
            ></iframe>
          </div>
        </IframeEmblueWrap>
      )}
      {isSet && !isEurope() && (
        <IframeCompareEmblueWrap>
          <div className="flex justify-center w-full">
            <iframe
              className="payments_iframe_compare_emblue"
              id="inlineFrameCompareEmblue"
              title="Inline Frame Emblue"
              src={t('ProductsPublicPage.iframeCompareEmblue')}
            ></iframe>
          </div>
        </IframeCompareEmblueWrap>
      )}
    </PublicLayout>
  );
};
